module.exports = __webpack_public_path__ + "fonts/IndivisibleWebRegularItalic.dafb3713.woff";